module.exports = __webpack_public_path__ + "img/Air-FranceKLM.1bed5b7f.png";